export default "__VITE_ASSET__BkSraDuF__"